import { initialValues } from 'civil-status/view-models/archive-annotations-list';
import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

const ArchiveAnnotationsInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

ArchiveAnnotationsInitializer.displayName = 'Archive Annotations Initializer component';

export default ArchiveAnnotationsInitializer;
